import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/auth.css';

export const AddTenantView: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [tenant, setTenant] = useState('');
  const [secret, setSecret] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { addTenant } = useAuth();
  const navigate = useNavigate();

  // Clear sensitive credentials from component state
  const clearCredentials = () => {
    setPassword('');
    setSecret('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    setIsLoading(true);

    try {
      await addTenant(username, password, tenant, secret);
      clearCredentials();
      navigate('/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to add tenant');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-box">
          <h2>Add Tenant Access</h2>
          <p className="auth-description">
            Already have an account? Register for access to another tenant.
          </p>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Email</label>
              <input
                type="email"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Your existing account email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Current Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Your existing account password"
              />
            </div>
            <div className="form-group">
              <label htmlFor="tenant">Tenant</label>
              <input
                type="text"
                id="tenant"
                value={tenant}
                onChange={(e) => setTenant(e.target.value)}
                required
                placeholder="The tenant you want to access"
              />
            </div>
            <div className="form-group">
              <label htmlFor="secret">Registration Code</label>
              <input
                type="text"
                id="secret"
                value={secret}
                onChange={(e) => setSecret(e.target.value)}
                required
                placeholder="Enter the registration code for this tenant"
              />
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Adding Tenant...' : 'Add Tenant Access'}
            </button>
          </form>
          <div className="auth-links">
            <a href="/login">Back to Login</a>
            <br /><br />
            <a href="/register">New User? Register Here</a>
          </div>
        </div>
      </div>
    </div>
  );
};
